import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import { Col, Row, Table } from "antd";

import PageHeading from "../../../../components/common/PageHeading";
import RightBar from "../../../../components/common/RightBar";
import RightBarMethod from "../../../../components/common/RightBar/RightBarMethod";

import { paymentBatchesData } from "../../../../data/accounting";

import "./PaymentBatches.css";

const PayablesPaymentBatchesRightBar = [
  RightBarMethod("", "", <i className=""></i>, [
    RightBarMethod("", "1", "", "", ""),
  ]),
];

function PaymentBatches() {
  const [sortedInfo, setSortedInfo] = useState({});

  const navigate = useNavigate();

  const handleChange = (sorter) => {
    setSortedInfo(sorter);
  };

  const columns = [
    {
      title: "Prepared On",
      dataIndex: "preparedOn",
      key: "preparedOn",
      sorter: (a, b) => a.preparedOn.length - b.preparedOn.length,
      sortOrder:
        sortedInfo.columnKey === "preparedOn" ? sortedInfo.order : null,
    },
    {
      title: "Prepared By",
      dataIndex: "preparedBy",
      key: "preparedBy",
      sorter: (a, b) => a.preparedBy.length - b.preparedBy.length,
      sortOrder:
        sortedInfo.columnKey === "preparedBy" ? sortedInfo.order : null,
    },
    {
      title: "Total Amount",
      dataIndex: "totalAmount",
      key: "totalAmount",
      sorter: (a, b) => a.totalAmount.length - b.totalAmount.length,
      sortOrder:
        sortedInfo.columnKey === "totalAmount" ? sortedInfo.order : null,
    },
  ];

  return (
    <>
      <div className="payment-batches">
        <PageHeading heading="Payment Batches" />
        <Row>
          <Col className="table-container" span={24}>
            <Table
              columns={columns}
              dataSource={[]}
              onChange={handleChange}
              pagination={false}
              onRow={(record) => {
                return {
                  onClick: () =>
                    navigate(
                      `/accounting/payables_bills/payment_batches/${record?.id}`
                    ),
                };
              }}
            />
          </Col>
        </Row>
      </div>
      <div className="RightSidebar">
        <RightBar RightBarData={PayablesPaymentBatchesRightBar} />
      </div>
    </>
  );
}

export default PaymentBatches;
